import { isNil } from 'lodash-es';
import { useRouter } from 'next/router';
import { type ReactNode, useEffect, useMemo, useRef } from 'react';

import { MY_URL } from '../../../constants/urls';
import useClientAccountProfileQuery from '../../../queries/useClientAccountProfileQuery';

interface PartnersGuardProps {
  children: ReactNode;
}

export const PartnersGuard = ({ children }: PartnersGuardProps) => {
  const alreadyPassed = useRef(false);
  const router = useRouter();
  const { data: profile, isLoading } = useClientAccountProfileQuery({});

  const isPartners = useMemo(() => profile && !isNil(profile.marketingPartner), [profile]);
  const shouldActivateGuard = useMemo(() => isPartners && !alreadyPassed.current, [isPartners]);

  useEffect(() => {
    if (shouldActivateGuard) {
      router.replace(MY_URL.PARTNERS());
    }
  }, [shouldActivateGuard]);

  useEffect(() => {
    if (!isLoading) {
      alreadyPassed.current = true;
    }
  }, [isLoading]);

  if (isLoading || shouldActivateGuard) {
    return <></>;
  }

  return <>{children}</>;
};
